<div class="mx-2">
  <div class="mt-4 gap-2">
    @if (checkPermission('pesquisar-paginado')) {
      <div class="card-style shadow radius gap-4 px-8 py-3 pt-6 mt-5">
        <div class="text-xl">
          Pesquisa
        </div>
        <form-client-search
          class="mb-0 w-full"
          [search]="inputSearch"
          [listSearch]="listSearch"
          (responseSearch)="search($event)"
        />
      </div>
      <div class="mt-3">
        <mat-form-field class="input-tg" appearance="outline">
          <mat-label>Ordenação</mat-label>
          <mat-select [(value)]="orderBySelected" (selectionChange)="sortChange($event)">
            @for (sort of sorts; track sort){
            <mat-option [value]="sort.id">
              {{ sort.description }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="createUser($event)"
            (activeItem)="statusItem($event)"
            (sendEmail)="generatePassword($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
